import { cn } from "@/lib/utils";
import { ChevronRight } from "lucide-react";
import { DIFF_DOT, excerpt } from "@/components/assessment/model";

export function QuestionOutline({ groups, current, onSelect, summary }) {
  return (
    <nav aria-label="Assessment questions" className="space-y-5 min-w-0 max-md:max-h-80 max-md:overflow-y-auto" data-testid="question-outline">
      <div className="space-y-0.5">
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>{summary.sections} sections · {summary.questions} questions</span>
          <span className="hs-mono">{summary.minutes} min</span>
        </div>
        <p className="text-[11px] text-muted-foreground/80">Select a question to review it</p>
      </div>
      {groups.map((g) => (
        <div key={g.name} className="space-y-0.5">
          <div className="flex items-center justify-between gap-2 px-1 pb-1 text-sm font-semibold">
            <span className="min-w-0 truncate" title={g.name}>{g.name}</span>
            {g.weight != null && <span className="hs-mono text-xs text-muted-foreground font-normal">{g.weight}%</span>}
          </div>
          {g.items.map((it) => {
            const on = current === it.number;
            return (
              <button key={it.number} onClick={() => onSelect(it.number)} aria-current={on ? "true" : undefined} data-testid={`outline-q-${it.number.replace(".", "-")}`}
                className={cn("group w-full flex items-center gap-2.5 rounded-lg border px-2.5 py-2 text-left text-[13px] cursor-pointer transition-[background-color,border-color,color]",
                  on ? "border-primary/40 bg-primary/10 text-foreground font-medium" : "border-transparent text-foreground/75 hover:border-border hover:bg-foreground/[0.05] hover:text-foreground")}>
                <span className={cn("hs-mono text-[11px] shrink-0 w-7", on ? "text-primary" : "text-muted-foreground")}>{it.number}</span>
                <span className="flex-1 min-w-0 truncate">{excerpt(it.prompt, 52)}</span>
                <span className={cn("h-1.5 w-1.5 rounded-full shrink-0", DIFF_DOT[it.difficulty] || "bg-muted-foreground/40")} title={it.difficulty || "No difficulty"} />
                <ChevronRight className={cn("h-3.5 w-3.5 shrink-0 transition-[opacity,transform]", on ? "text-primary opacity-100" : "opacity-0 -translate-x-1 group-hover:opacity-60 group-hover:translate-x-0")} />
              </button>
            );
          })}
        </div>
      ))}
    </nav>
  );
}
